import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { LoadingService } from '../../loading.service';
import { SnackService } from '../../snack.service';
import { Observable } from 'rxjs';
import { _post, DeserializeVoid } from '../../base.service';

@Injectable({
  providedIn: 'root',
})
export class TourInstallerDeleteAssetsControllerRequestService {
  private static BASE_URL = '/tourInstaller/deleteAssets';
  private readonly post: <T>(
    path: string,
    body: RequestBody,
    deserialize: (response: any) => T
  ) => Observable<T>;

  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.post = _post(
      TourInstallerDeleteAssetsControllerRequestService.BASE_URL,
      requestServices
    );
  }

  public deleteAssets(uuids: string[]): Promise<void> {
    const body: RequestBody = {
      uuids: uuids,
    };
    return this.post('', body, DeserializeVoid).toPromise();
  }
}

interface RequestBody {
  uuids: string[];
}
